import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class NavItemConstants {
  //used to fix initial routing
  energyCreditConstant: string = 'Energy Credits';
  eLearnConstant: string = 'eLearn';
}
